// 기존 FooterServicePrivacy.vue FooterServicePrivacyOld.vue를 조금 지성을 갖추도록 변경

const PrivacyList = [
    {ver: '20190409', contents: '<div>\n' +
            '        <p>엔에이치엔 주식회사(이하 "회사"라 함)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률,\n' +
            '          개인정보보호법, 통신비밀보호법, 전기통신사업법 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며,\n' +
            '          관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.</p>\n' +
            '        <p>본 개인정보처리방침은 회사가 제공하는 NCP 플랫폼의 서비스 어드민(이하 “SA”라 함) 서비스 이용에 적용되며 다음과 같은 내용을 담고 있습니다.</p>\n' +
            '        <ol class="dcs">\n' +
            '          <li><a href="#g1">1. 수집하는 개인정보의 항목 및 수집방법</a></li>\n' +
            '          <li><a href="#g2">2. 개인정보의 수집 및 이용목적</a></li>\n' +
            '          <li><a href="#g3">3. 개인정보 공유 및 제공</a></li>\n' +
            '          <li><a href="#g4">4. 개인정보의 처리위탁</a></li>\n' +
            '          <li><a href="#g5">5. 개인정보의 보유 및 이용기간</a></li>\n' +
            '          <li><a href="#g6">6. 개인정보 파기절차 및 방법</a></li>\n' +
            '          <li><a href="#g7">7. 이용자 및 법정대리인의 권리와 그 행사방법</a></li>\n' +
            '          <li><a href="#g8">8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</a></li>\n' +
            '          <li><a href="#g9">9. 개인정보의 기술적/관리적 보호대책</a></li>\n' +
            '          <li><a href="#g10">10. 개인정보보호책임자 및 담당자의 연락처</a></li>\n' +
            '          <li><a href="#g11">11. 기타</a></li>\n' +
            '          <li><a href="#g12">12. 고지의 의무</a></li>\n' +
            '        </ol>\n' +
            '        <h2 id="g1" class="privacy_ttl_h2">1. 수집하는 개인정보의 항목 및 수집방법</h2>\n' +
            '        <p class="dcs">회사가 제공하는 SA 운영자 계정생성 및 SA 서비스 제공을 위해 아래와 같이 이용자의 개인정보를 수집하고 있습니다.</p>\n' +
            '        <ol>\n' +
            '          <li>\n' +
            '            <h3>1) 수집하는 개인정보 항목</h3>\n' +
            '            <ul>\n' +
            '              <li>\n' +
            '                사업자 정보를 수집합니다.\n' +
            '                <ul>\n' +
            '                  <li>- (필수)회사명, 사업자 등록번호, 대표자명, 업종, 업태, 대표전화번호, 대표 e메일, 사업장 주소, 쇼핑몰명, 쇼핑몰계좌정보(계좌번호, 예금주명)</li>\n' +
            '                  <li>- (선택) 팩스번호, 통신판매신고번호, 개인정보 관리책임자 정보(담당자명, 전화번호)</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                계정 생성을 요청한 이용자의 개인정보를 수집합니다.\n' +
            '                <ul>\n' +
            '                  <li>- (필수) ID, 비밀번호, 성명, 직급, 전화번호, 휴대폰번호, 이메일</li>\n' +
            '                  <li>- (선택) 소속부서, 직책</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                서비스 이용과정에서 다음과 같은 정보가 생성되어 수집 될 수 있습니다.\n' +
            '                <ul>\n' +
            '                  <li>- 운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 개인정보 수집방법</h3>\n' +
            '            <ul>\n' +
            '              <li>\n' +
            '                회사는 SA 계정생성 시 이용자가 입력한 개인정보를 수집합니다.\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                생성정보 수집 툴을 통해 수집합니다.\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g2" class="privacy_ttl_h2">2. 개인정보의 수집 및 이용목적</h2>\n' +
            '        <p class="dcs">회사는 수집 한 개인정보를 다음과 같은 목적을 위해 활용합니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 서비스 제공에 대한 계약 이행 및 서비스 제공에 따른 요금정산</h3>\n' +
            '            <ul>\n' +
            '              <li>- 서비스 및 콘텐츠 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금결제, 요금추심</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 운영자 계정관리</h3>\n' +
            '            <ul>\n' +
            '              <li>- 서비스 제공, 개인식별, 부정 이용방지와 비인가 사용방지, 계정등록 의사 확인, 계정중복등록 제한, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 신규서비스 개발 및 마케팅</h3>\n' +
            '            <ul>\n' +
            '              <li>- 신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도\n' +
            '                파악, 회원의 서비스이용에 대한 통계</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g3" class="privacy_ttl_h2">3. 개인정보 공유 및 제공</h2>\n' +
            '        <p class="dcs">회사는 이용자들의 개인정보를 전항(2. 개인정보 수집목적 및 이용목적)에서\n' +
            '          고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에\n' +
            '          공개하지 않습니다. 다만, 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는\n' +
            '          경우에는 예외로 합니다.</p>\n' +
            '        <h2 id="g4" class="privacy_ttl_h2">4. 개인정보의 처리위탁</h2>\n' +
            '        <p class="dcs">회사는 SA 사용을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계\n' +
            '          법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 회사의 개인정보 위탁 처리 기관 및\n' +
            '          위탁업무 내용은 아래와 같습니다.</p>\n' +
            '        <table class="doc_table" style="display:table">\n' +
            '          <caption>개인정보의 처리 위탁</caption>\n' +
            '          <colgroup>\n' +
            '            <col style="width:40%">\n' +
            '            <col style="width:40%">\n' +
            '            <col>\n' +
            '          </colgroup>\n' +
            '          <thead>\n' +
            '            <tr>\n' +
            '              <th scope="col">수탁업체</th>\n' +
            '              <th scope="col">위탁업무 내용</th>\n' +
            '              <th scope="col">개인정보의 보유 및 이용기간</th>\n' +
            '            </tr>\n' +
            '          </thead>\n' +
            '          <tbody>\n' +
            '            <tr>\n' +
            '              <td>엔에이치엔서비스(주)</td>\n' +
            '              <td>NCP 관련 시스템 테스트,<br>서비스 관련 문의 대응</td>\n' +
            '              <td rowspan="2">회원 탈퇴 시 혹은 위탁계약 종료 시</td>\n' +
            '            </tr>\n' +
            '            <tr>\n' +
            '              <td>엔에이치엔한국사이버결제(주)</td>\n' +
            '              <td>휴대폰인증</td>\n' +
            '            </tr>\n' +
            '          </tbody>\n' +
            '        </table>\n' +
            '        <h2 id="g5" class="privacy_ttl_h2">5. 개인정보 보유 및 이용기간</h2>\n' +
            '        <p class="dcs">이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존하며, 그 외\n' +
            '          다른 목적으로는 절대 사용하지 않습니다.</p>\n' +
            '        <p class="dcs">- 관련 법령에 의한 정보 보유</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 권한내역 (권한부여, 변경, 삭제 등의 기록)</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률</li>\n' +
            '              <li>- 보관기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 접속기록 (운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역)</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률</li>\n' +
            '              <li>- 보관기간 : 1년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 소비자의 불만 또는 분쟁처리에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 3년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>4) 계약 또는 청약철회 등에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>5) 대금결제 및 재화 등의 공급에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g6" class="privacy_ttl_h2">6. 개인정보 파기절차 및 방법</h2>\n' +
            '        <p class="dcs">이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1). 파기절차 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자가 SA 운영자 계정등록을 위해 입력한 정보는 목적이 달성 된 후\n' +
            '                별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 법령에 의한 정보보호 사유에 따라 전항(5. 개인정보 보유\n' +
            '                및 이용기간)에서 정의한 기간 동안 저장 후 파기합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2). 파기방법</h3>\n' +
            '            <ul>\n' +
            '              <li>- 종이에 출력 된 정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>\n' +
            '              <li>- 전자적 파일의 형태로 제공된 개인정보는 기록을 재생 할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g7" class="privacy_ttl_h2">7. 이용자 및 법정대리인의 권리와 그 행사방법</h2>\n' +
            '        <ol class="no-tit">\n' +
            '          <li>1) 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며,\n' +
            '            회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 계정삭제(탈퇴)를 요청하실 수 있습니다. 단, 계정삭제 이후에는\n' +
            '            서비스의 이용이 불가능합니다.</li>\n' +
            '          <li>2) 이용자의 개인정보 조회 및 수정을 위해서는 이용자가 직접 ‘내 정보변경’기능을 통해서 가능하며 계정삭제는 계정관리 권한을 가진 운영자 또는 마스터 운영자를 통한 계정삭제가\n' +
            '            가능합니다.</li>\n' +
            '          <li>3) 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</li>\n' +
            '          <li>4) 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지\n' +
            '            당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게\n' +
            '            지체 없이 통지하여 정정이 이루어지도록 하겠습니다.</li>\n' +
            '          <li>5) 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는“5. 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고\n' +
            '            있습니다.</li>\n' +
            '        </ol>\n' +
            '        <h2 id="g8" class="privacy_ttl_h2">8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</h2>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 쿠키란</h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를\n' +
            '                저장하고 수시로 불러오는 \'쿠키(cookie)\'를 사용합니다. 쿠키는 웹 사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게\n' +
            '                보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 쿠키의 사용목적</h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자들이 이용한 회사의 각 서비스와 이용형태 등을 분석하여 이용자에게 최적화된 맞춤형 정보를 제공하기 위하여 쿠키를 이용합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 쿠키의 설치/운영 및 거부</h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면\n' +
            '                모든 쿠키의 저장을 거부할 수도 있습니다.</li>\n' +
            '              <li>- 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다. </li>\n' +
            '              <li>- 쿠키 설치 허용 여부를 지정하는 방법(Internet Explorer의 경우) <br>① [도구] 메뉴에서 [인터넷 옵션]을 선택합니다. <br>② [개인정보 탭]을\n' +
            '                클릭합니다. <br>③ [개인정보처리 수준]을 설정하시면 됩니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g9" class="privacy_ttl_h2">9. 개인정보의 기술적/관리적 보호대책</h2>\n' +
            '        <p class="dcs">회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고\n' +
            '          있습니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 비밀번호 암호화 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회원 아이디의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 해킹 등에 대비한 대책 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. </li>\n' +
            '              <li>- 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신\n' +
            '                백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여\n' +
            '                네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.</li>\n' +
            '              <li>- 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 처리직원의 최소화 및 교육 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사\n' +
            '                개인정보처리방침의 준수를 항상 강조하고 있습니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>4) 개인정보보호 전담기구의 운영 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 사내 개인정보보호전담기구 등을 통하여 회사 개인정보처리방침의 이행사항\n' +
            '                및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의\n' +
            '                부주의나 인터넷상의 문제로 ID, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지\n' +
            '                않습니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g10" class="privacy_ttl_h2">10. 개인정보보호책임자 및 담당자의 연락처</h2>\n' +
            '        <p class="dcs">회사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보\n' +
            '          보호책임자를 지정하고 있습니다. 귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자의\n' +
            '          연락처로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <div class="bx">\n' +
            '              <h3>1) 개인정보보호 책임자</h3>\n' +
            '              <ul>\n' +
            '                <li>- 성명 : 황선영</li>\n' +
            '                <li>- 소속 : 법무정책그룹</li>\n' +
            '                <li>- 직위 : 이사</li>\n' +
            '                <li>- 메일 : privacy_ne@nhnent.com</li>\n' +
            '              </ul>\n' +
            '            </div>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 기타 개인정보침해 신고나 상담이 필요하신 경우 아래기관에 문의하시기 바랍니다.</h3>\n' +
            '            <ul>\n' +
            '              <li>- 개인정보침해신고센터 (http://privacy.kisa.or.kr, 국번없이 118)</li>\n' +
            '              <li>- 대검찰청 사이버수사과 (http://www.spo.go.kr, 국번없이 1301)</li>\n' +
            '              <li>- 경찰청 사이버안전국(http://cyberbureau.police.go.kr, 국번없이 182)</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g11" class="privacy_ttl_h2">11. 기타</h2>\n' +
            '        <p class="dcs">회사가 제공하는 서비스에 링크되어 있는 웹페이지들이 개인정보를 수집하는 행위에 대해서는 본 "개인정보처리방침"이 적용되지 않음을 알려 드립니다.</p>\n' +
            '        <h2 id="g12" class="privacy_ttl_h2">12. 고지의 의무</h2>\n' +
            '        <p class="dcs">현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소\n' +
            '          7일전부터 SA 메인화면의 \'공지사항\'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자\n' +
            '          권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.</p>\n' +
            '        <p>버전 : v2.0<br>공고일자 : 2019년 4월 01일<br>시행일자 : 2019년 4월 09일</p>\n' +
            '      </div>'
    },
    {ver: '20200220', contents: '<div>\n' +
            '        <p>엔에이치엔 주식회사(이하 "회사"라 함)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률,\n' +
            '          개인정보보호법, 통신비밀보호법, 전기통신사업법 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며,\n' +
            '          관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.</p>\n' +
            '        <p>본 개인정보처리방침은 회사가 제공하는 NCP 플랫폼의 서비스 어드민(이하 “SA”라 함) 서비스 이용에 적용되며 다음과 같은 내용을 담고 있습니다.</p>\n' +
            '        <ol class="dcs">\n' +
            '          <li><a href="#g1">1. 수집하는 개인정보의 항목 및 수집방법</a></li>\n' +
            '          <li><a href="#g2">2. 개인정보의 수집 및 이용목적</a></li>\n' +
            '          <li><a href="#g3">3. 개인정보 공유 및 제공</a></li>\n' +
            '          <li><a href="#g4">4. 개인정보의 처리위탁</a></li>\n' +
            '          <li><a href="#g5">5. 개인정보의 보유 및 이용기간</a></li>\n' +
            '          <li><a href="#g6">6. 개인정보 파기절차 및 방법</a></li>\n' +
            '          <li><a href="#g7">7. 이용자 및 법정대리인의 권리와 그 행사방법</a></li>\n' +
            '          <li><a href="#g8">8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</a></li>\n' +
            '          <li><a href="#g9">9. 개인정보의 기술적/관리적 보호대책</a></li>\n' +
            '          <li><a href="#g10">10. 개인정보보호책임자의 연락처</a></li>\n' +
            '          <li><a href="#g11">11. 기타</a></li>\n' +
            '          <li><a href="#g12">12. 고지의 의무</a></li>\n' +
            '        </ol>\n' +
            '        <h2 id="g1" class="privacy_ttl_h2">1. 수집하는 개인정보의 항목 및 수집방법</h2>\n' +
            '        <p class="dcs">회사가 제공하는 SA 운영자 계정생성 및 SA 서비스 제공을 위해 아래와 같이 이용자의 개인정보를 수집하고 있습니다.</p>\n' +
            '        <ol>\n' +
            '          <li>\n' +
            '            <h3>1) 수집하는 개인정보 항목</h3>\n' +
            '            <ul>\n' +
            '              <li>\n' +
            '                사업자 정보를 수집합니다.\n' +
            '                <ul>\n' +
            '                  <li>- (필수)회사명, 사업자 등록번호, 대표자명, 업종, 업태, 대표전화번호, 대표 e메일, 사업장 주소, 쇼핑몰명, 쇼핑몰계좌정보(계좌번호, 예금주명)</li>\n' +
            '                  <li>- (선택) 팩스번호, 통신판매신고번호, 개인정보 관리책임자 정보(담당자명, 전화번호)</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                계정 생성을 요청한 이용자의 개인정보를 수집합니다.\n' +
            '                <ul>\n' +
            '                  <li>- (필수) ID, 비밀번호, 성명, 직급, 전화번호, 휴대폰번호, 이메일</li>\n' +
            '                  <li>- (선택) 소속부서, 직책</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                서비스 이용과정에서 다음과 같은 정보가 생성되어 수집 될 수 있습니다.\n' +
            '                <ul>\n' +
            '                  <li>- 운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 개인정보 수집방법</h3>\n' +
            '            <ul>\n' +
            '              <li>\n' +
            '                회사는 SA 계정생성 시 이용자가 입력한 개인정보를 수집합니다.\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                생성정보 수집 툴을 통해 수집합니다.\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g2" class="privacy_ttl_h2">2. 개인정보의 수집 및 이용목적</h2>\n' +
            '        <p class="dcs">회사는 수집 한 개인정보를 다음과 같은 목적을 위해 활용합니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 서비스 제공에 대한 계약 이행 및 서비스 제공에 따른 요금정산</h3>\n' +
            '            <ul>\n' +
            '              <li>- 서비스 및 콘텐츠 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금결제, 요금추심</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 운영자 계정관리</h3>\n' +
            '            <ul>\n' +
            '              <li>- 서비스 제공, 개인식별, 부정 이용방지와 비인가 사용방지, 계정등록 의사 확인, 계정중복등록 제한, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 신규서비스 개발 및 마케팅</h3>\n' +
            '            <ul>\n' +
            '              <li>- 신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도\n' +
            '                파악, 회원의 서비스이용에 대한 통계</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g3" class="privacy_ttl_h2">3. 개인정보 공유 및 제공</h2>\n' +
            '        <p class="dcs">회사는 이용자들의 개인정보를 전항(2. 개인정보 수집목적 및 이용목적)에서\n' +
            '          고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에\n' +
            '          공개하지 않습니다. 다만, 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는\n' +
            '          경우에는 예외로 합니다.</p>\n' +
            '        <h2 id="g4" class="privacy_ttl_h2">4. 개인정보의 처리위탁</h2>\n' +
            '        <p class="dcs">회사는 SA 사용을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계\n' +
            '          법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 회사의 개인정보 위탁 처리 기관 및\n' +
            '          위탁업무 내용은 아래와 같습니다.</p>\n' +
            '        <table class="doc_table" style="display:table">\n' +
            '          <caption>개인정보의 처리 위탁</caption>\n' +
            '          <colgroup>\n' +
            '            <col style="width:40%">\n' +
            '            <col style="width:40%">\n' +
            '            <col>\n' +
            '          </colgroup>\n' +
            '          <thead>\n' +
            '            <tr>\n' +
            '              <th scope="col">수탁업체</th>\n' +
            '              <th scope="col">위탁업무 내용</th>\n' +
            '              <th scope="col">개인정보의 보유 및 이용기간</th>\n' +
            '            </tr>\n' +
            '          </thead>\n' +
            '          <tbody>\n' +
            '            <tr>\n' +
            '              <td>엔에이치엔서비스(주)</td>\n' +
            '              <td>NCP 관련 시스템 테스트,<br>서비스 관련 문의 대응</td>\n' +
            '              <td rowspan="2">회원 탈퇴 시 혹은 위탁계약 종료 시</td>\n' +
            '            </tr>\n' +
            '            <tr>\n' +
            '              <td>엔에이치엔한국사이버결제(주)</td>\n' +
            '              <td>휴대폰인증</td>\n' +
            '            </tr>\n' +
            '          </tbody>\n' +
            '        </table>\n' +
            '        <h2 id="g5" class="privacy_ttl_h2">5. 개인정보 보유 및 이용기간</h2>\n' +
            '        <p class="dcs">이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존하며, 그 외\n' +
            '          다른 목적으로는 절대 사용하지 않습니다.</p>\n' +
            '        <p class="dcs">- 관련 법령에 의한 정보 보유</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 권한내역 (권한부여, 변경, 삭제 등의 기록)</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률</li>\n' +
            '              <li>- 보관기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 접속기록 (운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역)</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률</li>\n' +
            '              <li>- 보관기간 : 1년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 소비자의 불만 또는 분쟁처리에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 3년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>4) 계약 또는 청약철회 등에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>5) 대금결제 및 재화 등의 공급에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g6" class="privacy_ttl_h2">6. 개인정보 파기절차 및 방법</h2>\n' +
            '        <p class="dcs">이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1). 파기절차 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자가 SA 운영자 계정등록을 위해 입력한 정보는 목적이 달성 된 후\n' +
            '                별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 법령에 의한 정보보호 사유에 따라 전항(5. 개인정보 보유\n' +
            '                및 이용기간)에서 정의한 기간 동안 저장 후 파기합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2). 파기방법</h3>\n' +
            '            <ul>\n' +
            '              <li>- 종이에 출력 된 정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>\n' +
            '              <li>- 전자적 파일의 형태로 제공된 개인정보는 기록을 재생 할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g7" class="privacy_ttl_h2">7. 이용자 및 법정대리인의 권리와 그 행사방법</h2>\n' +
            '        <ol class="no-tit">\n' +
            '          <li>1) 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며,\n' +
            '            회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 계정삭제(탈퇴)를 요청하실 수 있습니다. 단, 계정삭제 이후에는\n' +
            '            서비스의 이용이 불가능합니다.</li>\n' +
            '          <li>2) 이용자의 개인정보 조회 및 수정을 위해서는 이용자가 직접 ‘내 정보변경’기능을 통해서 가능하며 계정삭제는 계정관리 권한을 가진 운영자 또는 마스터 운영자를 통한 계정삭제가\n' +
            '            가능합니다.</li>\n' +
            '          <li>3) 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</li>\n' +
            '          <li>4) 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지\n' +
            '            당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게\n' +
            '            지체 없이 통지하여 정정이 이루어지도록 하겠습니다.</li>\n' +
            '          <li>5) 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는“5. 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고\n' +
            '            있습니다.</li>\n' +
            '        </ol>\n' +
            '        <h2 id="g8" class="privacy_ttl_h2">8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</h2>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 쿠키란</h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를\n' +
            '                저장하고 수시로 불러오는 \'쿠키(cookie)\'를 사용합니다. 쿠키는 웹 사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게\n' +
            '                보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 쿠키의 사용목적</h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자들이 이용한 회사의 각 서비스와 이용형태 등을 분석하여 이용자에게 최적화된 맞춤형 정보를 제공하기 위하여 쿠키를 이용합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 쿠키의 설치/운영 및 거부</h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면\n' +
            '                모든 쿠키의 저장을 거부할 수도 있습니다.</li>\n' +
            '              <li>- 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다. </li>\n' +
            '              <li>- 쿠키 설치 허용 여부를 지정하는 방법\n' +
            '                <br>① Internet Explorer 웹 브라우저\n' +
            '                <br>[도구] &gt; [인터넷 옵션] &gt; [개인정보] 탭 &gt; [고급] 변경\n' +
            '                <br>② Chrome 웹 브라우저\n' +
            '                <br>우측 상단 메뉴 [설정] &gt; [도구] &gt; [개인정보 및 보안] &gt; [사이트 설정] &gt; [쿠키 및 사이트 데이터] 설정\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>4) 모바일 서비스에서의 쿠키 설치/운영 및 거부에 관한 사항</h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 PC 환경과 동일•유사한 인터넷 환경을 모바일 서비스에서도\n' +
            '                제공하기 위해 모바일 기기 (예: 스마트 폰, 태블릿 PC)에서도 \'쿠키(cookie)\'를 사용할 수 있습니다. 회사는 관련 법령\n' +
            '                및 규제기관의 가이드라인에 따라 쿠키를 수집하며 단, 이용자의 개인정보를 포함하여 그 자체로 개인을 식별할 수 있는 쿠키는\n' +
            '                이용자의 사전 동의 없이 임의로 수집하지 않습니다.\n' +
            '                <br>모바일 기기에서도 웹브라우저 설정 기능에서 쿠키 허용 여부를\n' +
            '                선택할 수 있습니다. 모바일 기기의 운영체제 및 웹 브라우저 종류에 따라 다소 상이할 수 있지만, 대부분의 경우 모바일\n' +
            '                웹브라우저의 환경 설정을 통해 쿠키허용 여부를 결정하거나, 기존의 쿠키 일체를 삭제할 수 있습니다. 다만 쿠키의 저장을 거부할\n' +
            '                경우, 로그인이 필요한 일부 서비스의 이용에 불편함이 있을 수 있습니다.\n' +
            '              </li>\n' +
            '              <li>- 쿠키 설치 허용 여부를 지정하는 방법\n' +
            '                <br>① Chrome 웹 브라우저\n' +
            '                <br>우측 상단 메뉴 [설정] &gt; [고급] &gt; [사이트 설정] &gt; [쿠키] 설정\n' +
            '                <br>② Safari 웹 브라우저\n' +
            '                <br>[설정] &gt; [Safari] &gt; [모든 쿠키 차단] &gt; 설정\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g9" class="privacy_ttl_h2">9. 개인정보의 기술적/관리적 보호대책</h2>\n' +
            '        <p class="dcs">회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고\n' +
            '          있습니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 개인정보 암호화 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 비밀번호 등 개인정보를 법령에서 요구하는 기준에 따라 암호화 처리하고 있으며, 중요한 데이터는 파일 및 전송 데이터를 암호화하는 등 별도의 보안 조치를 취하여 이용자의\n' +
            '                개인정보를 보호하고 있습니다.\n' +
            '                <br>회원 아이디의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 해킹 등에 대비한 대책 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. </li>\n' +
            '              <li>- 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신\n' +
            '                백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여\n' +
            '                네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.</li>\n' +
            '              <li>- 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 처리직원의 최소화 및 교육 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사\n' +
            '                개인정보처리방침의 준수를 항상 강조하고 있습니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>4) 개인정보보호 전담기구의 운영 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 사내 개인정보보호전담기구 등을 통하여 회사 개인정보처리방침의 이행사항\n' +
            '                및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의\n' +
            '                부주의나 인터넷상의 문제로 ID, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지\n' +
            '                않습니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g10" class="privacy_ttl_h2">10. 개인정보보호책임자의 연락처</h2>\n' +
            '        <p class="dcs">회사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보\n' +
            '          보호책임자를 지정하고 있습니다. 귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자의\n' +
            '          연락처로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <div class="bx">\n' +
            '              <h3>1) 개인정보보호 책임자</h3>\n' +
            '              <ul>\n' +
            '                <li>- 성명 : 황선영</li>\n' +
            '                <li>- 소속 : 법무정책그룹</li>\n' +
            '                <li>- 직위 : 이사</li>\n' +
            '                <li>- 메일 : nhn.privacy@nhn.com</li>\n' +
            '              </ul>\n' +
            '            </div>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 기타 개인정보침해 신고나 상담이 필요하신 경우 아래기관에 문의하시기 바랍니다.</h3>\n' +
            '            <ul>\n' +
            '              <li>- 개인정보침해신고센터 (http://privacy.kisa.or.kr, 국번없이 118)</li>\n' +
            '              <li>- 대검찰청 사이버수사과 (http://www.spo.go.kr, 국번없이 1301)</li>\n' +
            '              <li>- 경찰청 사이버안전지킴이 (http://www.police.go.kr/www/security/cyber.jsp, 국번없이 182)</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g11" class="privacy_ttl_h2">11. 기타</h2>\n' +
            '        <p class="dcs">회사가 제공하는 서비스에 링크되어 있는 웹페이지들이 개인정보를 수집하는 행위에 대해서는 본 "개인정보처리방침"이 적용되지 않음을 알려 드립니다.</p>\n' +
            '        <h2 id="g12" class="privacy_ttl_h2">12. 고지의 의무</h2>\n' +
            '        <p class="dcs">현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소\n' +
            '          7일전부터 SA 메인화면의 \'공지사항\'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자\n' +
            '          권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.</p>\n' +
            '        <p>버전 : v3.0<br>공고일자 : 2020년 2월 13일<br>시행일자 : 2020년 2월 20일</p>\n' +
            '      </div>'},
    {ver: '20200510', contents: '<div>\n' +
            '        <p>엔에이치엔주식회사(이하 "회사"라 함)는 정보통신서비스제공자가 준수하여야 하는\n' +
            '          대한민국의 관계 법령 및 개인정보보호 규정을 준수하며 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.</p>\n' +
            '        <p>본 개인정보처리방침은 회사가 제공하는 NCP 플랫폼의 서비스 어드민(이하 “SA”라 함) 서비스 이용에 적용되며 다음과 같은 내용을 담고 있습니다.</p>\n' +
            '        <ol class="dcs">\n' +
            '          <li><a href="#g1">1. 수집하는 개인정보의 항목 및 수집방법</a></li>\n' +
            '          <li><a href="#g2">2. 개인정보의 수집 및 이용목적</a></li>\n' +
            '          <li><a href="#g3">3. 개인정보 공유 및 제공</a></li>\n' +
            '          <li><a href="#g4">4. 개인정보의 처리위탁</a></li>\n' +
            '          <li><a href="#g5">5. 개인정보의 보유 및 이용기간</a></li>\n' +
            '          <li><a href="#g6">6. 개인정보 파기절차 및 방법</a></li>\n' +
            '          <li><a href="#g7">7. 이용자 및 법정대리인의 권리와 그 행사방법</a></li>\n' +
            '          <li><a href="#g8">8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</a></li>\n' +
            '          <li><a href="#g9">9. 개인정보의 기술적/관리적 보호대책</a></li>\n' +
            '          <li><a href="#g10">10. 개인정보보호책임자의 연락처</a></li>\n' +
            '          <li><a href="#g11">11. 기타</a></li>\n' +
            '          <li><a href="#g12">12. 고지의 의무</a></li>\n' +
            '        </ol>\n' +
            '        <h2 id="g1" class="privacy_ttl_h2">1. 수집하는 개인정보의 항목 및 수집방법</h2>\n' +
            '        <p class="dcs">회사가 제공하는 SA 운영자 계정생성 및 SA 서비스 제공을 위해 아래와 같이 이용자의 개인정보를 수집하고 있습니다.</p>\n' +
            '        <ol>\n' +
            '          <li>\n' +
            '            <h3>1) 수집하는 개인정보 항목</h3>\n' +
            '            <ul>\n' +
            '              <li>\n' +
            '                사업자 정보를 수집합니다.\n' +
            '                <ul>\n' +
            '                  <li>- (필수)회사명, 사업자 등록번호, 대표자명, 업종, 업태, 대표전화번호, 대표 e메일, 사업장 주소, 쇼핑몰명, 쇼핑몰계좌정보(계좌번호, 예금주명)</li>\n' +
            '                  <li>- (선택) 팩스번호, 통신판매신고번호, 개인정보 관리책임자 정보(담당자명, 전화번호)</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                계정 생성을 요청한 이용자의 개인정보를 수집합니다.\n' +
            '                <ul>\n' +
            '                  <li>- (필수) ID, 비밀번호, 성명, 직급, 전화번호, 휴대폰번호, 이메일</li>\n' +
            '                  <li>- (선택) 소속부서, 직책</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                서비스 이용과정에서 다음과 같은 정보가 생성되어 수집 될 수 있습니다.\n' +
            '                <ul>\n' +
            '                  <li>- 운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역</li>\n' +
            '                </ul>\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 개인정보 수집방법</h3>\n' +
            '            <ul>\n' +
            '              <li>\n' +
            '                회사는 SA 계정생성 시 이용자가 입력한 개인정보를 수집합니다.\n' +
            '              </li>\n' +
            '              <li>\n' +
            '                생성정보 수집 툴을 통해 수집합니다.\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g2" class="privacy_ttl_h2">2. 개인정보의 수집 및 이용목적</h2>\n' +
            '        <p class="dcs">회사는 수집 한 개인정보를 다음과 같은 목적을 위해 활용합니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 서비스 제공에 대한 계약 이행 및 서비스 제공에 따른 요금정산</h3>\n' +
            '            <ul>\n' +
            '              <li>- 서비스 및 콘텐츠 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금결제, 요금추심</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 운영자 계정관리</h3>\n' +
            '            <ul>\n' +
            '              <li>- 서비스 제공, 개인식별, 부정 이용방지와 비인가 사용방지, 계정등록 의사 확인, 계정중복등록 제한, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 신규서비스 개발 및 마케팅</h3>\n' +
            '            <ul>\n' +
            '              <li>- 신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도\n' +
            '                파악, 회원의 서비스이용에 대한 통계</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g3" class="privacy_ttl_h2">3. 개인정보 공유 및 제공</h2>\n' +
            '        <p class="dcs">회사는 이용자들의 개인정보를 전항(2. 개인정보 수집목적 및 이용목적)에서\n' +
            '          고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에\n' +
            '          공개하지 않습니다. 다만, 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는\n' +
            '          경우에는 예외로 합니다.</p>\n' +
            '        <h2 id="g4" class="privacy_ttl_h2">4. 개인정보의 처리위탁</h2>\n' +
            '        <p class="dcs">회사는 SA 사용을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계\n' +
            '          법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 회사의 개인정보 위탁 처리 기관 및\n' +
            '          위탁업무 내용은 아래와 같습니다.</p>\n' +
            '        <table class="doc_table" style="display:table">\n' +
            '          <caption>개인정보의 처리 위탁</caption>\n' +
            '          <colgroup>\n' +
            '            <col style="width:40%">\n' +
            '            <col style="width:40%">\n' +
            '            <col>\n' +
            '          </colgroup>\n' +
            '          <thead>\n' +
            '            <tr>\n' +
            '              <th scope="col">수탁업체</th>\n' +
            '              <th scope="col">위탁업무 내용</th>\n' +
            '              <th scope="col">개인정보의 보유 및 이용기간</th>\n' +
            '            </tr>\n' +
            '          </thead>\n' +
            '          <tbody>\n' +
            '            <tr>\n' +
            '              <td>엔에이치엔서비스(주)</td>\n' +
            '              <td>서비스 운영, 고객상담 및 품질관리, 서비스 테스트</td>\n' +
            '              <td rowspan="3">회원 탈퇴 시 혹은 위탁계약 종료 시</td>\n' +
            '            </tr>\n' +
            '            <tr>\n' +
            '              <td>엔에이치엔소프트(주)</td>\n' +
            '              <td>서비스 개발 및 QA, 기술지원, 디자인</td>\n' +
            '            </tr>\n' +
            '            <tr>\n' +
            '              <td>엔에이치엔한국사이버결제(주)</td>\n' +
            '              <td>휴대폰인증</td>\n' +
            '            </tr>\n' +
            '          </tbody>\n' +
            '        </table>\n' +
            '        <h2 id="g5" class="privacy_ttl_h2">5. 개인정보 보유 및 이용기간</h2>\n' +
            '        <p class="dcs">이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존하며, 그 외\n' +
            '          다른 목적으로는 절대 사용하지 않습니다.</p>\n' +
            '        <p class="dcs">- 관련 법령에 의한 정보 보유</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 권한내역 (권한부여, 변경, 삭제 등의 기록)</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률</li>\n' +
            '              <li>- 보관기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 접속기록 (운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역)</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률</li>\n' +
            '              <li>- 보관기간 : 1년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 소비자의 불만 또는 분쟁처리에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 3년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>4) 계약 또는 청약철회 등에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>5) 대금결제 및 재화 등의 공급에 관한 기록</h3>\n' +
            '            <ul>\n' +
            '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
            '              <li>- 보존 기간 : 5년</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g6" class="privacy_ttl_h2">6. 개인정보 파기절차 및 방법</h2>\n' +
            '        <p class="dcs">이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1). 파기절차 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자가 SA 운영자 계정등록을 위해 입력한 정보는 목적이 달성 된 후\n' +
            '                별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 법령에 의한 정보보호 사유에 따라 전항(5. 개인정보 보유\n' +
            '                및 이용기간)에서 정의한 기간 동안 저장 후 파기합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2). 파기방법</h3>\n' +
            '            <ul>\n' +
            '              <li>- 종이에 출력 된 정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>\n' +
            '              <li>- 전자적 파일의 형태로 제공된 개인정보는 기록을 재생 할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g7" class="privacy_ttl_h2">7. 이용자 및 법정대리인의 권리와 그 행사방법</h2>\n' +
            '        <ol class="no-tit">\n' +
            '          <li>1) 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며,\n' +
            '            회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 계정삭제(탈퇴)를 요청하실 수 있습니다. 단, 계정삭제 이후에는\n' +
            '            서비스의 이용이 불가능합니다.</li>\n' +
            '          <li>2) 이용자의 개인정보 조회 및 수정을 위해서는 이용자가 직접 ‘내 정보변경’기능을 통해서 가능하며 계정삭제는 계정관리 권한을 가진 운영자 또는 마스터 운영자를 통한 계정삭제가\n' +
            '            가능합니다.</li>\n' +
            '          <li>3) 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</li>\n' +
            '          <li>4) 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지\n' +
            '            당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게\n' +
            '            지체 없이 통지하여 정정이 이루어지도록 하겠습니다.</li>\n' +
            '          <li>5) 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는“5. 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고\n' +
            '            있습니다.</li>\n' +
            '        </ol>\n' +
            '        <h2 id="g8" class="privacy_ttl_h2">8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</h2>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 쿠키란</h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를\n' +
            '                저장하고 수시로 불러오는 \'쿠키(cookie)\'를 사용합니다. 쿠키는 웹 사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게\n' +
            '                보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 쿠키의 사용목적</h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자들이 이용한 회사의 각 서비스와 이용형태 등을 분석하여 이용자에게 최적화된 맞춤형 정보를 제공하기 위하여 쿠키를 이용합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 쿠키의 설치/운영 및 거부</h3>\n' +
            '            <ul>\n' +
            '              <li>- 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면\n' +
            '                모든 쿠키의 저장을 거부할 수도 있습니다.</li>\n' +
            '              <li>- 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다. </li>\n' +
            '              <li>- 쿠키 설치 허용 여부를 지정하는 방법\n' +
            '                <br>① Internet Explorer 웹 브라우저\n' +
            '                <br>[도구] &gt; [인터넷 옵션] &gt; [개인정보] 탭 &gt; [고급] 변경\n' +
            '                <br>② Chrome 웹 브라우저\n' +
            '                <br>우측 상단 메뉴 [설정] &gt; [도구] &gt; [개인정보 및 보안] &gt; [사이트 설정] &gt; [쿠키 및 사이트 데이터] 설정\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>4) 모바일 서비스에서의 쿠키 설치/운영 및 거부에 관한 사항</h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 PC 환경과 동일•유사한 인터넷 환경을 모바일 서비스에서도\n' +
            '                제공하기 위해 모바일 기기 (예: 스마트 폰, 태블릿 PC)에서도 \'쿠키(cookie)\'를 사용할 수 있습니다. 회사는 관련 법령\n' +
            '                및 규제기관의 가이드라인에 따라 쿠키를 수집하며 단, 이용자의 개인정보를 포함하여 그 자체로 개인을 식별할 수 있는 쿠키는\n' +
            '                이용자의 사전 동의 없이 임의로 수집하지 않습니다.\n' +
            '                <br>모바일 기기에서도 웹브라우저 설정 기능에서 쿠키 허용 여부를\n' +
            '                선택할 수 있습니다. 모바일 기기의 운영체제 및 웹 브라우저 종류에 따라 다소 상이할 수 있지만, 대부분의 경우 모바일\n' +
            '                웹브라우저의 환경 설정을 통해 쿠키허용 여부를 결정하거나, 기존의 쿠키 일체를 삭제할 수 있습니다. 다만 쿠키의 저장을 거부할\n' +
            '                경우, 로그인이 필요한 일부 서비스의 이용에 불편함이 있을 수 있습니다.\n' +
            '              </li>\n' +
            '              <li>- 쿠키 설치 허용 여부를 지정하는 방법\n' +
            '                <br>① Chrome 웹 브라우저\n' +
            '                <br>우측 상단 메뉴 [설정] &gt; [고급] &gt; [사이트 설정] &gt; [쿠키] 설정\n' +
            '                <br>② Safari 웹 브라우저\n' +
            '                <br>[설정] &gt; [Safari] &gt; [모든 쿠키 차단] &gt; 설정\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g9" class="privacy_ttl_h2">9. 개인정보의 기술적/관리적 보호대책</h2>\n' +
            '        <p class="dcs">회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고\n' +
            '          있습니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <h3>1) 개인정보 암호화 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 비밀번호 등 개인정보를 법령에서 요구하는 기준에 따라 암호화 처리하고 있으며, 중요한 데이터는 파일 및 전송 데이터를 암호화하는 등 별도의 보안 조치를 취하여 이용자의\n' +
            '                개인정보를 보호하고 있습니다.\n' +
            '                <br>회원 아이디의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 해킹 등에 대비한 대책 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. </li>\n' +
            '              <li>- 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신\n' +
            '                백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여\n' +
            '                네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.</li>\n' +
            '              <li>- 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.\n' +
            '              </li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>3) 처리직원의 최소화 및 교육 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사\n' +
            '                개인정보처리방침의 준수를 항상 강조하고 있습니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>4) 개인정보보호 전담기구의 운영 </h3>\n' +
            '            <ul>\n' +
            '              <li>- 사내 개인정보보호전담기구 등을 통하여 회사 개인정보처리방침의 이행사항\n' +
            '                및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의\n' +
            '                부주의나 인터넷상의 문제로 ID, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지\n' +
            '                않습니다.</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g10" class="privacy_ttl_h2">10. 개인정보보호책임자의 연락처</h2>\n' +
            '        <p class="dcs">회사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보\n' +
            '          보호책임자를 지정하고 있습니다. 귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자의\n' +
            '          연락처로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.</p>\n' +
            '        <ol class="nobld">\n' +
            '          <li>\n' +
            '            <div class="bx">\n' +
            '              <h3>1) 개인정보보호 책임자</h3>\n' +
            '              <ul>\n' +
            '                <li>- 성명 : 황선영</li>\n' +
            '                <li>- 소속 : 법무정책그룹</li>\n' +
            '                <li>- 직위 : 이사</li>\n' +
            '                <li>- 메일 : nhn.privacy@nhn.com</li>\n' +
            '              </ul>\n' +
            '            </div>\n' +
            '          </li>\n' +
            '          <li>\n' +
            '            <h3>2) 기타 개인정보침해 신고나 상담이 필요하신 경우 아래기관에 문의하시기 바랍니다.</h3>\n' +
            '            <ul>\n' +
            '              <li>- 개인정보침해신고센터 (http://privacy.kisa.or.kr, 국번없이 118)</li>\n' +
            '              <li>- 대검찰청 사이버수사과 (http://www.spo.go.kr, 국번없이 1301)</li>\n' +
            '              <li>- 경찰청 사이버안전지킴이 (http://www.police.go.kr/www/security/cyber.jsp, 국번없이 182)</li>\n' +
            '            </ul>\n' +
            '          </li>\n' +
            '        </ol>\n' +
            '        <h2 id="g11" class="privacy_ttl_h2">11. 기타</h2>\n' +
            '        <p class="dcs">회사가 제공하는 서비스에 링크되어 있는 웹페이지들이 개인정보를 수집하는 행위에 대해서는 본 "개인정보처리방침"이 적용되지 않음을 알려 드립니다.</p>\n' +
            '        <h2 id="g12" class="privacy_ttl_h2">12. 고지의 의무</h2>\n' +
            '        <p class="dcs">현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소\n' +
            '          7일전부터 SA 메인화면의 \'공지사항\'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자\n' +
            '          권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.</p>\n' +
            '        <p>버전 : v4.0<br>공고일자 : 2021년 5월 3일<br>시행일자 : 2021년 5월 10일</p>\n' +
            '      </div>'
    },
    {ver: '20220203', contents: '<div>\n' +
      '        <p>엔에이치엔커머스 주식회사(이하 "회사"라 함)는 정보통신서비스제공자가 준수하여야 하는\n' +
      '          대한민국의 관계 법령 및 개인정보보호 규정을 준수하며 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.</p>\n' +
      '        <p>본 개인정보처리방침은 회사가 제공하는 shop by 플랫폼의 서비스 어드민(이하 “SA”라 함) 서비스 이용에 적용되며 다음과 같은 내용을 담고 있습니다.</p>\n' +
      '        <ol class="dcs">\n' +
      '          <li><a href="#g1">1. 수집하는 개인정보의 항목 및 수집방법</a></li>\n' +
      '          <li><a href="#g2">2. 개인정보의 수집 및 이용목적</a></li>\n' +
      '          <li><a href="#g3">3. 개인정보 공유 및 제공</a></li>\n' +
      '          <li><a href="#g4">4. 개인정보의 처리위탁</a></li>\n' +
      '          <li><a href="#g5">5. 개인정보의 보유 및 이용기간</a></li>\n' +
      '          <li><a href="#g6">6. 개인정보 파기절차 및 방법</a></li>\n' +
      '          <li><a href="#g7">7. 이용자 및 법정대리인의 권리와 그 행사방법</a></li>\n' +
      '          <li><a href="#g8">8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</a></li>\n' +
      '          <li><a href="#g9">9. 개인정보의 기술적/관리적 보호대책</a></li>\n' +
      '          <li><a href="#g10">10. 개인정보보호책임자의 연락처</a></li>\n' +
      '          <li><a href="#g11">11. 기타</a></li>\n' +
      '          <li><a href="#g12">12. 고지의 의무</a></li>\n' +
      '        </ol>\n' +
      '        <h2 id="g1" class="privacy_ttl_h2">1. 수집하는 개인정보의 항목 및 수집방법</h2>\n' +
      '        <p class="dcs">회사가 제공하는 SA 운영자 계정생성 및 SA 서비스 제공을 위해 아래와 같이 이용자의 개인정보를 수집하고 있습니다.</p>\n' +
      '        <ol>\n' +
      '          <li>\n' +
      '            <h3>1) 수집하는 개인정보 항목</h3>\n' +
      '            <ul>\n' +
      '              <li>\n' +
      '                사업자 정보를 수집합니다.\n' +
      '                <ul>\n' +
      '                  <li>- (필수)회사명, 사업자 등록번호, 대표자명, 업종, 업태, 대표전화번호, 대표 e메일, 사업장 주소, 쇼핑몰명, 쇼핑몰계좌정보(계좌번호, 예금주명)</li>\n' +
      '                  <li>- (선택) 팩스번호, 통신판매신고번호, 개인정보 관리책임자 정보(담당자명, 전화번호)</li>\n' +
      '                </ul>\n' +
      '              </li>\n' +
      '              <li>\n' +
      '                계정 생성을 요청한 이용자의 개인정보를 수집합니다.\n' +
      '                <ul>\n' +
      '                  <li>- (필수) ID, 비밀번호, 성명, 직급, 전화번호, 휴대폰번호, 이메일</li>\n' +
      '                  <li>- (선택) 소속부서, 직책</li>\n' +
      '                </ul>\n' +
      '              </li>\n' +
      '              <li>\n' +
      '                서비스 이용과정에서 다음과 같은 정보가 생성되어 수집 될 수 있습니다.\n' +
      '                <ul>\n' +
      '                  <li>- 운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역</li>\n' +
      '                </ul>\n' +
      '              </li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>2) 개인정보 수집방법</h3>\n' +
      '            <ul>\n' +
      '              <li>\n' +
      '                회사는 SA 계정생성 시 이용자가 입력한 개인정보를 수집합니다.\n' +
      '              </li>\n' +
      '              <li>\n' +
      '                생성정보 수집 툴을 통해 수집합니다.\n' +
      '              </li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '        </ol>\n' +
      '        <h2 id="g2" class="privacy_ttl_h2">2. 개인정보의 수집 및 이용목적</h2>\n' +
      '        <p class="dcs">회사는 수집 한 개인정보를 다음과 같은 목적을 위해 활용합니다.</p>\n' +
      '        <ol class="nobld">\n' +
      '          <li>\n' +
      '            <h3>1) 서비스 제공에 대한 계약 이행 및 서비스 제공에 따른 요금정산</h3>\n' +
      '            <ul>\n' +
      '              <li>- 서비스 및 콘텐츠 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금결제, 요금추심</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>2) 운영자 계정관리</h3>\n' +
      '            <ul>\n' +
      '              <li>- 서비스 제공, 개인식별, 부정 이용방지와 비인가 사용방지, 계정등록 의사 확인, 계정중복등록 제한, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>3) 신규서비스 개발 및 마케팅</h3>\n' +
      '            <ul>\n' +
      '              <li>- 신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도\n' +
      '                파악, 회원의 서비스이용에 대한 통계</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '        </ol>\n' +
      '        <h2 id="g3" class="privacy_ttl_h2">3. 개인정보 공유 및 제공</h2>\n' +
      '        <p class="dcs">회사는 이용자들의 개인정보를 전항(2. 개인정보 수집목적 및 이용목적)에서\n' +
      '          고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에\n' +
      '          공개하지 않습니다. 다만, 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는\n' +
      '          경우에는 예외로 합니다.</p>\n' +
      '        <h2 id="g4" class="privacy_ttl_h2">4. 개인정보의 처리위탁</h2>\n' +
      '        <p class="dcs">회사는 SA 사용을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계\n' +
      '          법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 회사의 개인정보 위탁 처리 기관 및\n' +
      '          위탁업무 내용은 아래와 같습니다.</p>\n' +
      '        <table class="doc_table" style="display:table">\n' +
      '          <caption>개인정보의 처리 위탁</caption>\n' +
      '          <colgroup>\n' +
      '            <col style="width:40%">\n' +
      '            <col style="width:40%">\n' +
      '            <col>\n' +
      '          </colgroup>\n' +
      '          <thead>\n' +
      '            <tr>\n' +
      '              <th scope="col">수탁업체</th>\n' +
      '              <th scope="col">위탁업무 내용</th>\n' +
      '              <th scope="col">개인정보의 보유 및 이용기간</th>\n' +
      '            </tr>\n' +
      '          </thead>\n' +
      '          <tbody>\n' +
      '            <tr>\n' +
      '              <td>엔에이치엔서비스(주)</td>\n' +
      '              <td>서비스 운영, 고객상담 및 품질관리, 서비스 테스트</td>\n' +
      '              <td rowspan="3">회원 탈퇴 시 혹은 위탁계약 종료 시</td>\n' +
      '            </tr>\n' +
      '            <tr>\n' +
      '              <td>엔에이치엔소프트(주)</td>\n' +
      '              <td>서비스 개발 및 QA, 기술지원, 디자인</td>\n' +
      '            </tr>\n' +
      '            <tr>\n' +
      '              <td>엔에이치엔한국사이버결제(주)</td>\n' +
      '              <td>휴대폰인증</td>\n' +
      '            </tr>\n' +
      '          </tbody>\n' +
      '        </table>\n' +
      '        <h2 id="g5" class="privacy_ttl_h2">5. 개인정보 보유 및 이용기간</h2>\n' +
      '        <p class="dcs">이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존하며, 그 외\n' +
      '          다른 목적으로는 절대 사용하지 않습니다.</p>\n' +
      '        <p class="dcs">- 관련 법령에 의한 정보 보유</p>\n' +
      '        <ol class="nobld">\n' +
      '          <li>\n' +
      '            <h3>1) 권한내역 (권한부여, 변경, 삭제 등의 기록)</h3>\n' +
      '            <ul>\n' +
      '              <li>- 보존이유 : 개인정보보호법</li>\n' +
      '              <li>- 보관기간 : 5년</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>2) 접속기록 (운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역)</h3>\n' +
      '            <ul>\n' +
      '              <li>- 보존이유 : 개인정보보호법</li>\n' +
      '              <li>- 보관기간 : 1년</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>3) 소비자의 불만 또는 분쟁처리에 관한 기록</h3>\n' +
      '            <ul>\n' +
      '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
      '              <li>- 보존 기간 : 3년</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>4) 계약 또는 청약철회 등에 관한 기록</h3>\n' +
      '            <ul>\n' +
      '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
      '              <li>- 보존 기간 : 5년</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>5) 대금결제 및 재화 등의 공급에 관한 기록</h3>\n' +
      '            <ul>\n' +
      '              <li>- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>\n' +
      '              <li>- 보존 기간 : 5년</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '        </ol>\n' +
      '        <h2 id="g6" class="privacy_ttl_h2">6. 개인정보 파기절차 및 방법</h2>\n' +
      '        <p class="dcs">이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.</p>\n' +
      '        <ol class="nobld">\n' +
      '          <li>\n' +
      '            <h3>1). 파기절차 </h3>\n' +
      '            <ul>\n' +
      '              <li>- 이용자가 SA 운영자 계정등록을 위해 입력한 정보는 목적이 달성 된 후\n' +
      '                별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 법령에 의한 정보보호 사유에 따라 전항(5. 개인정보 보유\n' +
      '                및 이용기간)에서 정의한 기간 동안 저장 후 파기합니다.</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>2). 파기방법</h3>\n' +
      '            <ul>\n' +
      '              <li>- 종이에 출력 된 정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>\n' +
      '              <li>- 전자적 파일의 형태로 제공된 개인정보는 기록을 재생 할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '        </ol>\n' +
      '        <h2 id="g7" class="privacy_ttl_h2">7. 이용자 및 법정대리인의 권리와 그 행사방법</h2>\n' +
      '        <ol class="no-tit">\n' +
      '          <li>1) 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며,\n' +
      '            회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 계정삭제(탈퇴)를 요청하실 수 있습니다. 단, 계정삭제 이후에는\n' +
      '            서비스의 이용이 불가능합니다.</li>\n' +
      '          <li>2) 이용자의 개인정보 조회 및 수정을 위해서는 이용자가 직접 ‘내 정보변경’기능을 통해서 가능하며 계정삭제는 계정관리 권한을 가진 운영자 또는 마스터 운영자를 통한 계정삭제가\n' +
      '            가능합니다.</li>\n' +
      '          <li>3) 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</li>\n' +
      '          <li>4) 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지\n' +
      '            당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게\n' +
      '            지체 없이 통지하여 정정이 이루어지도록 하겠습니다.</li>\n' +
      '          <li>5) 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는“5. 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고\n' +
      '            있습니다.</li>\n' +
      '        </ol>\n' +
      '        <h2 id="g8" class="privacy_ttl_h2">8. 개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</h2>\n' +
      '        <ol class="nobld">\n' +
      '          <li>\n' +
      '            <h3>1) 쿠키란</h3>\n' +
      '            <ul>\n' +
      '              <li>- 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를\n' +
      '                저장하고 수시로 불러오는 \'쿠키(cookie)\'를 사용합니다. 쿠키는 웹 사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게\n' +
      '                보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>2) 쿠키의 사용목적</h3>\n' +
      '            <ul>\n' +
      '              <li>- 이용자들이 이용한 회사의 각 서비스와 이용형태 등을 분석하여 이용자에게 최적화된 맞춤형 정보를 제공하기 위하여 쿠키를 이용합니다.</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>3) 쿠키의 설치/운영 및 거부</h3>\n' +
      '            <ul>\n' +
      '              <li>- 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면\n' +
      '                모든 쿠키의 저장을 거부할 수도 있습니다.</li>\n' +
      '              <li>- 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다. </li>\n' +
      '              <li>- 쿠키 설치 허용 여부를 지정하는 방법\n' +
      '                <br>① Internet Explorer 웹 브라우저\n' +
      '                <br>[도구] &gt; [인터넷 옵션] &gt; [개인정보] 탭 &gt; [고급] 변경\n' +
      '                <br>② Chrome 웹 브라우저\n' +
      '                <br>우측 상단 메뉴 [설정] &gt; [도구] &gt; [개인정보 및 보안] &gt; [사이트 설정] &gt; [쿠키 및 사이트 데이터] 설정\n' +
      '              </li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>4) 모바일 서비스에서의 쿠키 설치/운영 및 거부에 관한 사항</h3>\n' +
      '            <ul>\n' +
      '              <li>- 회사는 PC 환경과 동일•유사한 인터넷 환경을 모바일 서비스에서도\n' +
      '                제공하기 위해 모바일 기기 (예: 스마트 폰, 태블릿 PC)에서도 \'쿠키(cookie)\'를 사용할 수 있습니다. 회사는 관련 법령\n' +
      '                및 규제기관의 가이드라인에 따라 쿠키를 수집하며 단, 이용자의 개인정보를 포함하여 그 자체로 개인을 식별할 수 있는 쿠키는\n' +
      '                이용자의 사전 동의 없이 임의로 수집하지 않습니다.\n' +
      '                <br>모바일 기기에서도 웹브라우저 설정 기능에서 쿠키 허용 여부를\n' +
      '                선택할 수 있습니다. 모바일 기기의 운영체제 및 웹 브라우저 종류에 따라 다소 상이할 수 있지만, 대부분의 경우 모바일\n' +
      '                웹브라우저의 환경 설정을 통해 쿠키허용 여부를 결정하거나, 기존의 쿠키 일체를 삭제할 수 있습니다. 다만 쿠키의 저장을 거부할\n' +
      '                경우, 로그인이 필요한 일부 서비스의 이용에 불편함이 있을 수 있습니다.\n' +
      '              </li>\n' +
      '              <li>- 쿠키 설치 허용 여부를 지정하는 방법\n' +
      '                <br>① Chrome 웹 브라우저\n' +
      '                <br>우측 상단 메뉴 [설정] &gt; [고급] &gt; [사이트 설정] &gt; [쿠키] 설정\n' +
      '                <br>② Safari 웹 브라우저\n' +
      '                <br>[설정] &gt; [Safari] &gt; [모든 쿠키 차단] &gt; 설정\n' +
      '              </li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '        </ol>\n' +
      '        <h2 id="g9" class="privacy_ttl_h2">9. 개인정보의 기술적/관리적 보호대책</h2>\n' +
      '        <p class="dcs">회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고\n' +
      '          있습니다.</p>\n' +
      '        <ol class="nobld">\n' +
      '          <li>\n' +
      '            <h3>1) 개인정보 암호화 </h3>\n' +
      '            <ul>\n' +
      '              <li>- 회사는 비밀번호 등 개인정보를 법령에서 요구하는 기준에 따라 암호화 처리하고 있으며, 중요한 데이터는 파일 및 전송 데이터를 암호화하는 등 별도의 보안 조치를 취하여 이용자의\n' +
      '                개인정보를 보호하고 있습니다.\n' +
      '                <br>회원 아이디의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>2) 해킹 등에 대비한 대책 </h3>\n' +
      '            <ul>\n' +
      '              <li>- 회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. </li>\n' +
      '              <li>- 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신\n' +
      '                백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여\n' +
      '                네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.</li>\n' +
      '              <li>- 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.\n' +
      '              </li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>3) 처리직원의 최소화 및 교육 </h3>\n' +
      '            <ul>\n' +
      '              <li>- 회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사\n' +
      '                개인정보처리방침의 준수를 항상 강조하고 있습니다.</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>4) 개인정보보호 전담기구의 운영 </h3>\n' +
      '            <ul>\n' +
      '              <li>- 사내 개인정보보호전담기구 등을 통하여 회사 개인정보처리방침의 이행사항\n' +
      '                및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의\n' +
      '                부주의나 인터넷상의 문제로 ID, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지\n' +
      '                않습니다.</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '        </ol>\n' +
      '        <h2 id="g10" class="privacy_ttl_h2">10. 개인정보보호책임자의 연락처</h2>\n' +
      '        <p class="dcs">회사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보\n' +
      '          보호책임자를 지정하고 있습니다. 귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자의\n' +
      '          연락처로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.</p>\n' +
      '        <ol class="nobld">\n' +
      '          <li>\n' +
      '            <div class="bx">\n' +
      '              <h조3>1) 개인정보보호 책임자</h조3>\n' +
      '              <ul>\n' +
      '                <li>- 성명 : 김종승</li>\n' +
      '                <li>- 메일 : privacy1@nhn-commerce.com</li>\n' +
      '              </ul>\n' +
      '            </div>\n' +
      '          </li>\n' +
      '          <li>\n' +
      '            <h3>2) 기타 개인정보침해 신고나 상담이 필요하신 경우 아래기관에 문의하시기 바랍니다.</h3>\n' +
      '            <ul>\n' +
      '              <li>- 개인정보침해신고센터 (http://privacy.kisa.or.kr, 국번없이 118)</li>\n' +
      '              <li>- 대검찰청 사이버수사과 (http://www.spo.go.kr, 국번없이 1301)</li>\n' +
      '              <li>- 경찰청 사이버안전지킴이 (http://www.police.go.kr/www/security/cyber.jsp, 국번없이 182)</li>\n' +
      '            </ul>\n' +
      '          </li>\n' +
      '        </ol>\n' +
      '        <h2 id="g11" class="privacy_ttl_h2">11. 기타</h2>\n' +
      '        <p class="dcs">회사가 제공하는 서비스에 링크되어 있는 웹페이지들이 개인정보를 수집하는 행위에 대해서는 본 "개인정보처리방침"이 적용되지 않음을 알려 드립니다.</p>\n' +
      '        <h2 id="g12" class="privacy_ttl_h2">12. 고지의 의무</h2>\n' +
      '        <p class="dcs">현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소\n' +
      '          7일전부터 SA 메인화면의 \'공지사항\'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자\n' +
      '          권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.</p>\n' +
      '        <p>버전 : v5.0<br>공고일자 : 2022년 1월 3일<br>시행일자 : 2022년 2월 3일</p>\n' +
      '      </div>'
  },
];
export default PrivacyList;
